import {
  useContext,
  createContext,
  ReactNode,
  useState,
  useCallback,
} from 'react';

interface IDragAndDropProviderProps {
  children: ReactNode;
}

export type Field = {
  id: string;
  name: string;
};

export type DragAndDropContextData = {
  field: Field;
  dragField: (value: Field) => void;
  clear: () => void;
};

const DragAndDropContext = createContext({} as DragAndDropContextData);

export function DragAndDropProvider({ children }: IDragAndDropProviderProps) {
  const [field, setField] = useState<Field>({} as Field);

  const dragField = useCallback((value: Field) => {
    setField(value);
  }, []);

  const clear = useCallback(() => {
    setField({} as Field);
  }, []);

  return (
    <DragAndDropContext.Provider value={{ field, dragField, clear }}>
      {children}
    </DragAndDropContext.Provider>
  );
}

export const useDragAndDrop = () => useContext(DragAndDropContext);
